// extracted by mini-css-extract-plugin
export default {"cls1":"InviteRegisterYubikey-Section_cls1__5+isx","cls2":"InviteRegisterYubikey-Section_cls2__IFmN2 InviteRegisterYubikey-Section_cls1__5+isx"};